import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Provincia } from "../../../common/models/tipologiche/provincia";
import { SoggettoPratica } from "../../../common/models/tipologiche/soggetto-pratica";
import { TipoTipologica } from "../../../common/models/tipologiche/tipo-tipologica";
import { HelpersService } from "../../../core/services/helpers.service";
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-opposaiserviziispettivi',
  templateUrl: './form-opposaiserviziispettivi.component.html',
  styleUrls: ['./form-opposaiserviziispettivi.component.css']
})
export class FormOpposaiserviziispettiviComponent implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  soggettiOptions: SoggettoPratica[] = [];
  organiIspettiviOptions: TipoTipologica[] = [];
  provinceOptions: Provincia[] = [];
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;
  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  // @Output() tipoRichiedenteChanged = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(private campiForm: FormBuilder, private helpers: HelpersService) { }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.fascicolo);
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      // dataNotificaAtto: [init ? null : this.request.fascicolo.dataNotificaAtto, Validators.required],
      oggetto: [init ? null : this.request.fascicolo.oggetto],
      societa: [init ? null : this.request.fascicolo.societa],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      opposizione: [init ? false : this.request.fascicolo.opposizione, Validators.required],
      organoIspettivo: [init ? null : this.request.fascicolo.organoIspettivo, Validators.required],
      provincia: [init ? null : this.request.fascicolo.provincia, Validators.required],
      note: [init ? null : this.request.fascicolo.note],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
    });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  populateSelect() {
    if (this.soggettiOptions.length === 0) {
      this.helpers.getSoggetti().subscribe(response => this.soggettiOptions = response);
    }
    if (this.organiIspettiviOptions.length === 0) {
      this.helpers.getOrganiIspettivi().subscribe(response => this.organiIspettiviOptions = response);
    }
    if (this.provinceOptions.length === 0) {
      this.helpers.getProvince().subscribe(response => this.provinceOptions = response);
    }
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }

  save() {
    this.saveForm.emit();
  }
}
